import { Shield } from 'lucide-react';
import { Badge } from '../../ui/badge.tsx';
import { typeLabel } from '../derive.ts';
import type { UsersTableRow } from '../types.ts';

/**
 * Type column: Metron staff or an outside user. One source of truth — the
 * `metron-internal` Cognito group — and "Unknown" when that lookup failed, so a
 * failure is never rendered as "External".
 *
 * The string rendered here is exactly `row.sortKeys.type`, which is what the
 * column sorts on.
 */
export function TypeCell({ row }: { row: UsersTableRow }) {
  const label = typeLabel(row.type);

  if (row.type === 'metron') {
    return (
      <Badge variant='secondary' className='text-xs'>
        <Shield className='h-2.5 w-2.5 mr-0.5' />
        {label}
      </Badge>
    );
  }
  if (row.type === 'external') {
    return <Badge variant='outline' className='text-xs'>{label}</Badge>;
  }
  return <span className='text-sm text-muted-foreground'>{label}</span>;
}
